import { useEffect, useState } from "react";

const FiltersHojaVida = () => {
  const [filtered, setFiltered] = useState([]);
  const [data, setData] = useState([]);

  const handleFilter = (info) => {
    setData(info);
  };

  useEffect(() => {
    setFiltered(data || []);
  }, [data]);

  const onChangeSerial = (event) => {
    const value = event.target.value;
    if (!value) {
      setFiltered(data || []);
      return;
    }

    const filter = data?.filter((item) =>
      item.serial.toLowerCase().includes(value.toLowerCase())
    );

    setFiltered(filter);
  };

  return { filtered, handleFilter, onChangeSerial };
};

export default FiltersHojaVida;
